/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export class GlobalConstants {
  // dialogs names according to the tool-item.data.ts structure
  public static ABOUT_ELECTRICAL_NAME_DIALOG = 'About Electrical';
  public static IMPORT_SCHEDULE_NAME_DIALOG = 'Import Schedule';
  public static CREATE_SYSTEM_NAME_DIALOG = 'Create System';
  public static RENAME_SYSTEM_NAME_DIALOG = 'Rename System';
  public static DELETE_SYSTEM_NAME_DIALOG = 'Delete System';
  public static DUPLICATE_SYSTEM_NAME_DIALOG = 'Duplicate System';
  public static CREATE_CATEGORY_NAME_DIALOG = 'Create Category';
  public static RENAME_CATEGORY_NAME_DIALOG = 'Rename Category';
  public static DELETE_CATEGORY_NAME_DIALOG = 'Delete Category';
  public static APPLY_PANEL_DATA_NAME_DIALOG = 'Apply Panel/Circuit Data';
  public static CONFIGURATION_EXPORT_DIALOG = 'Configuration Export';
  public static CONFIGURATION_LOCATION_NAME_DIALOG = 'Configuration Location';
  public static PLACE_COUPLING_DIALOG = 'Place Coupling';
  public static CONVERT_SYSTEM_DIALOG = 'Convert System';
  public static APPLY_CONDUIT_ID_DIALOG = 'Apply Conduit ID';
  public static APPLY_EQUIPMENT_ID_DIALOG = 'Apply Equipment/Device ID';
  public static ADD_FITTING_DIALOG = 'Add Fittings';
  public static ANNOTATION_SETTINGS_DIALOG = 'Annotations Settings';
  public static SPECIFICATION_SETTINGS_DIALOG = 'Specification Settings';
  public static CABLE_TRAY_FAMILY_INFORMATION_DIALOG = 'Cable Tray Family Information';
  public static CONDUIT_FAMILY_INFORMATION_DIALOG = 'Conduit Family Information';
  public static JUNCTION_BOX_FAMILY_INFORMATION_DIALOG = 'Junction Box Family Information';
  public static FIELD_FAB_FAMILY_INFORMATION_DIALOG = 'Field Fab Family Information';
  public static HAND_AND_MACHINE_BEND_FAMILY_INFORMATION_DIALOG = 'Hand and Machine Bend Family Information';
  public static KICK_HAND_AND_MACHINE_BEND_FAMILY_INFORMATION_DIALOG = 'Kick Hand and Machine Bend Family Information';
  public static USER_CUSTOM_CONTENT_FAMILY_INFORMATION_DIALOG = 'User Custom Content Family Information';
  public static HANGER_SPECIFICATION_FAMILY_INFORMATION_DIALOG = 'Hanger Specification Family Information';
  public static SYSTEM_MANAGER_DIALOG = 'System Manager';
  public static ELECTRICAL_SETTINGS_DIALOG = 'Electrical Settings';
  public static ADD_NEW_PROJECT_DIALOG = 'Add New Project';
  public static PROJECT_DATA_DIALOG = 'Project Data';
  public static FIELDFAB_MARKS_DIALOG = 'Field fab';
  public static CONDUITRUN_EDIT_DIALOG = 'Conduit Run Edit';
  public static ALIGN_COUPLINGS_DIALOG = 'Align Couplings';
  public static OBJECT_UNITE_DIALOG = 'Object Unite';
  public static IMPORT_SYSTEMS_DIALOG = 'Import Systems';
  public static ASSIGN_PROJECT_DIALOG = 'Assign Project';
  public static APPLY_EQUIPMENT_DEVICE_ID_DIALOG = 'Apply Equipment / Device ID';
  public static ADD_NEW_PROJECT_PARAMETER_DIALOG = 'Add New Project Parameter';
  public static CHANGE_PRIORITY_DIALOG = 'Change Priority';
  public static CONDUIT_REPORT_DIALOG = 'Conduit Information';
  public static CABLETRAY_REPORT_DIALOG = 'Cable Tray Information';
  public static PANELCIRCUIT_REPORT_DIALOG = 'Panel/Circuit Information';
  public static SYSQUE_GAUGE_DIALOG = 'Direct Take Off';
  public static APPLY_EQUIPMENT_DETAILS = 'Apply Equipment Details';
  public static CODE_CHECKING = 'Code Checking';
  public static APPLY_SYSTEM_DATA = 'Apply System Data';
  public static APPLY_NOMINAL_SIZE = 'Apply Nominal Size';
  public static UPDATE_EXTENDED_DATA = 'Update Extended Data';
  public static GO_TO_SYSTEM = 'Go To System';

  //local storage keys
  public static UPDATE_PROCESS_FITTINGS_ONLY = 'ProcessFittingsOnlyUpdate';
  public static SYSTEM_STATE = 'systemState';
  public static SELECTED_TAB_CURATE_SEARCH = 'Curate Search';
  public static SELECTED_TAB_TREE_VIEW = 'Tree View';
  public static SYSTEM_INFO = 'systemInfo';
  public static ADD_FITTING_INFO = 'addToSystemResponse';
  public static MANAGE_MODE_SYSTEM_STATE = 'manageModeSystemState';
  public static SYSTEM_CREATION_SUCCESS = 'systemCreationSuccess';
  public static CATEGORY_CREATION_SUCCESS = 'categoryCreationSuccess';
  public static MSG_TITLE = 'msgTitle';
  public static MSG_CONTENT = 'msgContent';
  public static PANEL_DATA_RESPONSE = 'applyPanelDataResponse';
  public static DOCKABLE_CIRCUIT = 'dockableCircuit';
  public static ADD_TO_SYSTEM_ALERT = 'addToSystemAlert';
  public static CONFIGURATION_LOCATION = 'configurationLocation';
  public static PROJECT_CREATION_SUCCESS = 'addNewProjectSuccess';
  public static IMPORT_SYSTEMS_FILE = 'ImportSystemsFile';
  public static IMPORT_SYSTEMS_SUCCESS = 'importSystemsSuccess';
  public static SYSTEM_MANAGER_OPERATIONS_SUCCESS = 'systemManagerOperationsSuccess';
  public static SYSQUE_ELECTRICAL_STATE_KEY = 'dockedSystemState';
  public static REORDERED_FITTINGS_SUCCESS = 'reorderedFittingsSuccess';
  public static LINE_GRAPHICS_SUCCESS = 'lineGraphicsSuccess';
  public static REFRESH_ADD_FITTING_DIALOG_DATA = 'refreshAddFittingDialogData';
  public static SHOW_LINKED_PROJECT_MESSAGE = 'TetheredConfigurationApplied';
  public static ACRYLIC_OVERLAY = 'acrylicOverlay';
  public static RESET_DOCK_TO_INITIAL_STATE = 'ResetDockToTheInitialState';

  public static ACRYLIC_SURFACE = 'ShowAcrylicSurface';
  public static MANAGE_MODE_WINDOW = 'ManageModeOperations';
  public static MANAGE_MODE_SOURCE_SYSTEM_STATE = 'manageModeSourceSystemState';
  public static MANAGE_MODE_DESTINATION_SYSTEM_STATE = 'manageModeDestinationSystemState';
  public static SYSTEM_DELETED_SUCCESS = 'systemDeletedSuccess';
  public static SYSTEM_RENAMED_SUCCESS = 'systemRenamedSuccess';
  public static SYSTEM_DUPLICATED_SUCCESS = 'systemDuplicatedSuccess';
  public static CATEGORY_RENAMED_SUCCESS = 'categoryRenamedSuccess';
  public static CATEGORY_DELETED_SUCCESS = 'categoryDeletedSuccess';
  public static PLACE_COUPLING_RESPONSE = 'PlaceCouplingResponse';
  public static CONVERT_SYSTEM_RESPONSE = 'ConvertSystemResponse';
  public static CONVERT_OPTION_TITLE = 'convertOptionTitle';
  public static PANEL_LIST = 'panelList';
  public static PROJECT_LIST = 'projectList';
  public static SCOPE = 'scope';
  public static STORAGE = 'storage';
  public static ELEMENT_SELECTION_STATUS = 'ElementSelectionStatus';
  public static DOCKABLE_PANEL_DATA_RESPONSE = 'dockableApplyPanelDataResponse';
  public static ADD_FITTING_MODE_CLICKED = 'addFittingModeClicked';
  public static SELECTED_SYSTEM_NAME = 'SelectedSystemName';
  public static DOCKABLE_PANEL_DATA_FITTING_COUNT = 'dockablePanelDataFittingCount';
  public static PROJECT_PARAMS = 'projectParams';
  public static UPDATE_PROJECT_PARAMS_SIZES = 'updateAssignParametersSizesState';
  public static SHOW_NON_STANDARD_RESPONSE = 'showNonStandardResponse';
  public static ROTATE_ELEMENT_RESPONSE = 'rotateElementResponse';
  public static SHIFT_SEGMENT_RESPONSE = 'shiftSegmentResponse';
  public static WORKSHARING_SYNC_NECESSARY = 'worksharingSyncNecessary';
  public static WORKSHARING_PROGRESS_START = 'worksharingProgressStart';
  public static DUPLICATION_DEFAULT_TYPE_NOT_FOUND = 'duplicationDefaultTypeNotFound';
  public static PROJECT_DATA_CURRENT_CATEGORY = 'projectDataCurrentCategory';
  public static EXISTING_FITTING_LIST = 'existingFittingList';
  public static IS_SYSQUE_CONNECT_ON = 'isSysQueConnectOn';
  public static IS_DIRECT_TAKEOFF_ENABLED = 'isDirectTakeOffEnabled';
  public static SYSQUE_CONNECT_RESULT = 'sysQueConnectResult';
  public static SHOW_ACRYLIC_SURFACE = 'showAcrylicSurface';
  public static DOWNLOAD_MISSING_FAMILIES = 'downloadMissingFamilies';
  public static UPDATE_FAMILIES = 'updateFamilies';
  public static UPDATE_SHOW_NON_STADARD = 'updateShowNonStandard';
  public static ROTATE_ELEMENT = 'rotateElement';
  public static NO_SYSTEM_SELECTED = 'noSystemSelected';
  public static DOWNLOAD_MISSING_FAMILIES_SUCCESS = 'downloadMissingFamiliesSuccess';
  public static DOWNLOAD_GENERIC_FAMILIES = 'downloadGenericFamilies';
  public static CHECK_MISSING_FAMILIES = 'checkMissingFamilies';
  public static SET_UP_HANGER = 'setUpHanger';
  public static PANEL_DATA_VALIDATION_RESPONSE = 'applyPanelDataValidationResponse';
  public static SYSTEM_NAME_GO_TO_SYSTEM = 'sendSystemNameForGoToSystem';
  public static UPDATE_PROJECT_LIST = 'updateProjectList';
  public static UPDATE_PANEL_LIST = 'updatePanelList';
  public static SYSQUE_CONNECT_SYSTEM_NAME = 'sysQueConnectSystem';
  public static RELOAD_FITTINGS = 'reloadFittings';
  public static PROJECT_PARAM_TO_MODIFY = 'projectParamToModify';
  public static GAUGE_DIAMETER_AND_SIZE = 'gaugeDiameterAndSize';
  public static ELECTRICAL_SETTINGS_SAVE_SUCCESS = 'electricalSettingsSaveSuccess';
  public static IS_TOOLTIP_ON = 'isTooltipOn';
  public static UPDATE_PANEL_TYPE = 'updatePanelType';
  public static SYSTEM_NAME_DOES_NOT_EXIST = 'systemNameDoesNotExist';
  public static FEATURE_MAY_NOT_WORK_WITH_SELECTION = 'featureDoesNotWorkWithSelection';
  public static SELECT_CONDUIT_CABLE_TRAY_FITTING = 'selectConduitCableTrayFitting';
  public static DOCK_RELEASE_VERSION_LICENSE_STATUS = 'dockReleaseVersionLicenseStatus';
  
  //#region Electrical Settings

  public static ChangesAppliedSuccessfully = 'Changes have been applied successfully.';
  public static None = 'None';
  public static Both = 'Both';
  public static ImageFamilyName = 'Image with family name';
  public static ImageInstanceDescription = 'Image with instance description';
  public static ImageTypeDescription = 'Image with type description';
  public static DescriptionInstance = 'Description instance';
  public static DescriptionType = 'Description type';
  public static KeyboardShortcuts = 'Keyboard Shortcuts';
  public static Preferences = 'Preferences';
  public static SysQueSettings = 'SysQue Settings';
  public static NoValue = 'No value';
  public static Modifiers = 'modifiers';
  public static KeyOne = 'keyOne';
  public static KeyTwo = 'keyTwo';
  public static ModifierPlaceholder = 'Modifier';
  public static KeyOnePlaceholder = 'Key 1';
  public static KeyTwoPlaceholder = 'Key 2';
  public static ModifierNotFound = 'Please select a value for modifiers for ';
  public static Key1NotFound = 'Please select a value for key1 for ';
  public static DuplicateModifiersKey1 = 'Modifiers and Key1 cannot have the same values. Please try another key combination';
  public static DuplicateModifiersKey2 = 'Modifiers and Key2 cannot have the same values. Please try another key combination';
  public static DuplicateKey1Key2 = 'Key1 and Key2 cannot have the same values. Please try another key combination';
  public static KeyCombinationAlreadyAssigned = 'Key combination is already assigned. Please try another key combination';
  public static KeyCombinationAlreadyAssignedTo = 'Key combination is already assigned to ';
  public static PleaseTryAnotherKeyCombination = ' application. Please try another key combination';
  public static KeyCombinationExistInRevit = 'Key combination is already assigned to another Revit command. Please try another key combination';

  //#endregion

  //#region Annotation Settings data

  //local storage keys for annotation settings
  // all data from xml file
  public static ANNOTATION_SETTINGS_DATA_FROM_XML_NAME = 'annotationSettingsDataFromXML';

  public static GET_ANNOTATION_SETTINGS_INFO_METHOD_NAME = 'GetAnnotationSettingsInfo';
  public static SAVE_ANNOTATION_SETTINGS_INFO_METHOD_NAME = 'SaveAnnotationSettingsInfo';
  public static GET_REVIT_INFORMATION_METHOD_NAME = 'GetRevitInformation';
  public static GET_TAG_LOCATION_PATH_METHOD_NAME = 'GetTagLocationPath';
  public static IS_CURRENT_SELECTION_VALID_METHOD_NAME = 'IsCurrentSelectionValid';
  public static APPLY_DATA_METHOD_NAME = 'ApplyData';

  // cable tray data selections from local storage
  public static CABLE_TRAY_SIZE_DATA_SELECTION_NAME = 'cableTraySizeDataSelection';
  public static CABLE_TRAY_ELEVATION_DATA_SELECTION_NAME = 'cableTrayElevationDataSelection';
  public static CABLE_TRAY_ITEM_NUMBER_DATA_SELECTION_NAME = 'cableTrayItemNumberDataSelection';
  public static CABLE_TRAY_SPOOL_DATA_SELECTION_NAME = 'cableTraySpoolDataSelection';

  // conduit data selections from local storage
  public static CONDUIT_SETTINGS_SIZE_DATA_SELECTION_NAME = 'conduitSettingsSizeDataSelection';
  public static CONDUIT_SETTINGS_ELEVATION_DATA_SELECTION_NAME = 'conduitSettingsElevationDataSelection';
  public static CONDUIT_SETTINGS_ITEM_NUMBER_DATA_SELECTION_NAME = 'conduitSettingsItemNumberDataSelection';
  public static CONDUIT_SETTINGS_SPOOL_DATA_SELECTION_NAME = 'conduitSettingsSpoolDataSelection';

  //tag states from local storage
  public static CABLE_TRAY_TAGS_STATE = 'cableTrayTagsState';
  public static CONDUIT_SETTINGS_TAGS_STATE = 'conduitSettingsTagsState';

  // annotation settings tab names
  public static CONDUIT_SETTINGS_TAB_NAME = 'ConduitSettings';
  public static CABLE_TRAY_TAB_NAME = 'CableTray';

  // annotation settings tag label names
  public static SIZE_TAG_NAME = 'Size Tag';
  public static ELEVATION_TAG_NAME = 'Elevation Tag';
  public static ITEM_NUMBER_TAG_NAME = 'Item Number Tag';
  public static SPOOL_TAG_NAME = 'Spool Tag';

  // annotation settings names from xml
  public static SIZE_ANNOTATION_NAME = 'Size';
  public static ELEVATION_ANNOTATION_NAME = 'Elevation';
  public static ITEM_NUMBER_ANNOTATION_NAME = 'Item No';
  public static SPOOL_ANNOTATION_NAME = 'Spool';

  // annotation settings placement label names
  public static PLACEMENT_LABEL = 'Placement';
  public static DEFAULT = 'Default';
  public static ABOVE = 'Above';
  public static CENTER = 'Center';
  public static BELOW = 'Below';

  // annotation settings offset label names
  public static OFFSET_LABEL = 'Offset';
  public static X_OFFSET = 'X-Offset';
  public static Y_OFFSET = 'Y-Offset';

  // annotation settings occurrence label names
  public static OCCURRENCE_LABEL = 'Occurrence';
  public static AT_SIZE_CHANGE = 'At Size Change';
  public static AT_ELEVATION_CHANGE = 'At Elevation Change';
  public static UPON_SIZE_OR_DIRECTION_CHANGE = 'Upon Size or Direction Change';
  public static PER_SPOOL = 'Per Spool';

  // annotation settings occurrence label names from xml
  public static DIRECTION = 'Direction';
  public static SIZE_CHANGE = 'Size Change';
  public static ELEVATION_CHANGE = 'Elevation Change';
  public static ONE_ITEM = 'One Item';

  // annotation settings properties label names
  public static PROPERTIES_LABEL = 'Properties';
  public static SHOW_LEADER = 'Show Leader';
  public static HORIZONTAL_TEXT = 'Horizontal Text';
  public static SHOW_BORDER = 'Show Border';

  // from xml file
  public static TRUE = 'True';
  public static FALSE = 'False';

  // annotation settings ignore straights under label names
  public static IGNORE_STRAIGHTS_LABEL = 'Ignore straights under';

  // annotation settings location label names
  public static SIZE_LOCATION_LABEL = 'Size Tag Location';
  public static ELEVATION_LOCATION_LABEL = 'Elevation Tag Location';
  public static ITEM_NUMBER_LOCATION_LABEL = 'Item Number Tag Location';
  public static SPOOL_LOCATION_LABEL = 'Spool Tag Location';

  // annotation settings fitting location label names
  public static SIZE_FITTING_LOCATION_LABEL = 'Fitting Size Tag Location';
  public static ELEVATION_FITTINGS_LOCATION_LABEL = 'Fittings Elevation Tag Location';
  public static ITEM_NUMBER_FITTINGS_LOCATION_LABEL = 'Fittings Item Number Tag Location';
  public static SPOOL_FITTINGS_LOCATION_LABEL = 'Fittings Spool Tag Location';

  // annotation settings messages
  public static APPLY_DATA_SUCCESS = 'Annotation Applied successfully.';
  public static SAVE_DATA_SUCCESS = 'Annotation Saved successfully.';
  public static PLEASE_SELECT_ONE_ELEMENT = 'Please select at least one element.';
  public static VIEW_3D_UNLOCKED = '3D View is unlocked.';
  public static SELECTED_TAG_WRONG_CATEGORY = 'Selected Tag is not of the Correct Category.';

  public static SUPPORT_PATH = 'C:\\ProgramData\\BuildingData\\Support';
  public static TAG_FAMILIES_PATH =
    GlobalConstants.SUPPORT_PATH + '\\SysQue Annotation Tags\\' + 'ElectricalTagFamily - ';

  public static CONDUIT_SIZE_TAG = 'SysQue Conduit Size';
  public static CONDUIT_ELEVATION_TAG = 'SysQue Conduit Elevation BOC';
  public static CONDUIT_SPOOL_TAG = 'SysQue Conduit Spool Number';
  public static CONDUIT_FITTING_SPOOL_TAG = 'SysQue Conduit Fitting Spool Number';
  public static CONDUIT_ITEM_NUMBER_TAG = 'SysQue Conduit Item Number';
  public static CONDUIT_ITEM_NUMBER_FITTING_TAG = 'SysQue Conduit Fitting Item Number';

  public static CABLETRAY_SIZE_TAG = 'SysQue Cable Tray Size';
  public static CABLETRAY_SIZE_FITTING_TAG = 'SysQue Cable Tray Fitting Size';
  public static CABLETRAY_ELEVATION_TAG = 'SysQue Cable Tray Elevation BOCT';
  public static CABLETRAY_ELEVATION_FITTING_TAG = 'SysQue Cable Tray Fitting Elevation BOCT';
  public static CABLETRAY_SPOOL_TAG = 'SysQue Cable Tray Spool Number';
  public static CABLETRAY_FITTING_SPOOL_TAG = 'SysQue Cable Tray Fitting Spool Number';
  public static CABLETRAY_ITEM_NUMBER_TAG = 'SysQue Cable Tray Item Number';
  public static CABLETRAY_ITEM_NUMBER_FITTING_TAG = 'SysQue Cable Tray Fitting Item Number';

  public static TAG_FAMILY_EXTENSION = '.1.100.rfa';
  public static REVIT_VERSION = 'RevitVersion';

  //#endregion

  //#region Family Information

  //labels
  public static NEW_CABLE_TRAY_TITLE = 'New CableTray';
  public static NEW_CONDUIT_TITLE = 'New Conduit';
  public static ITEM_TYPE_LABEL = 'Item Type';
  public static PART_TYPE_LABEL = 'Part Type';
  public static PART_ID_LABEL = 'Part ID';
  public static CABLE_TRAY_NAME_LABEL = 'Cable Tray Name';
  public static CONDUIT_NAME_LABEL = 'Conduit Name';
  public static MANUFACTURER_LABEL = 'Manufacturer';
  public static MATERIAL_LABEL = 'Material';
  public static ADDED_WIRE_LENGTH_LABEL = 'Additional Wire Length';
  public static ID_LABEL = 'Id';
  public static LENGTH_LABEL = 'Length';
  public static SERVICE_TYPE_LABEL = 'Service Type';
  public static ANGLE_LABEL = 'Angle';
  public static MAX_BEND_ANGLE_LABEL = 'Max Bend Angle';
  public static MAX_DIAMETER_LABEL = 'Max Diameter';
  public static MAX_WIDTH_LABEL = 'Max Width';
  public static MAX_DEPTH_LABEL = 'Max Depth';
  public static ROD_DIAMETER_LABEL = 'Rod Diameter';
  public static HANGER_SPACING_LABEL = 'Hanger Spacing';
  public static DISTANCE_FROM_FITTINGS_LABEL = 'Distance from Fittings';
  public static DISTANCE_FROM_COUPLINGS_LABEL = 'Distance from Couplings';
  public static DISTANCE_FROM_EDGE_OF_BEAM_LABEL = 'Distance from Edge of Beam';
  public static ROD_LENGTH_LABEL = 'Rod Length';
  public static CONNECTORS_LABEL = 'Connectors';
  public static SUPPORT_DISCIPLINE_LABEL = 'Support Discipline';
  public static DISCIPLINE_LABEL = 'Discipline';
  public static INSTANCE_DESCRIPTION_LABEL = 'Instance Description';
  public static TYPE_DESCRIPTION_LABEL = 'Type Description';
  public static PROJECT_DATA_LABEL = 'Project Data';
  public static NO_OVERRIDE_LABEL = 'No Override';
  public static PANEL_CIRCUIT_LABEL = 'Panel Circuit';
  public static FIELD_FAB_CONDUIT_LABEL = 'Field Fab Conduit';
  public static WALL_TYPE_LABEL = 'Wall Type';
  public static SIZE_RANGE_LABEL = 'Size Range';
  public static HANGER_LABEL = 'Hanger';
  public static CATEGORY_LABEL = 'Category';
  public static NOMINAL_SIZE_LABEL = 'Nominal Size';

  public static UNION = 'Union';
  public static TRANSITION = 'Transition';
  public static NORMAL = 'Normal';
  public static MULTI_PORT = 'MultiPort';

  public static ENABLED = 'Enabled';
  public static DISABLED = 'Disabled';
  public static ON = 'On';
  public static OFF = 'Off';
  public static YES = 'Yes';
  public static NO = 'No';

  public static GET_ADD_FAMILY_INFORMATION_METHOD_NAME = 'GetAddFamilyInformation';
  public static GET_ADD_FAMILY_INFORMATION_DIALOG_TYPE = 'GetAddFamilyInformationDialogType';
  public static SAVE_FAMILY_INFORMATION_IN_XML = 'SaveFamilyInformationInXml';
  public static GET_PDF_LOCATION_PATH_METHOD_NAME = 'GetPdfLocationPath';
  public static OPEN_PDF_FILE_METHOD_NAME = 'OpenPdfFile';
  public static SAVE_SERVICE_TYPE = 'SaveServiceType';
  public static DELETE_SERVICE_TYPE = 'DeleteServiceType';
  public static GET_USER_CUSTOM_IMAGE_METHOD_NAME = 'GetUserCustomImage';
  public static VALIDATE_AND_GET_DATA_METHOD_NAME = 'ValidateAndGetData';
  public static DEVICE_EQUIPMENT_DETAILS_APPLY_DATA_METHOD_NAME = 'DeviceEquipmentDetailsApplyData';

  public static FAMILY_INFORMATION_ITEM = 'familyInformationItem';
  public static INPUT_DATA_FROM_ITEM = 'inputDataFromItem';
  public static FAMILY_INFORMATION_RESPONSE = 'familyInformationResponse';
  public static FAMILY_INFORMATION_DIALOG_WAS_CREATED = 'addFamilyInformationDialogWasCreated';

  public static IMPERIAL_HANGERS = '\\imperial\\hangers\\';
  public static METRIC_HANGERS = '\\metric\\hangers\\';

  public static ELECTRICAL_TYPE_ITEMS = 'ElectricalTypeItems';
  public static ADD_DEFAULT_ITEM = 'AddDefaultItem';
  public static METRIC = 'Metric';
  public static IMPORT_EXPORT_EXCEL_RESPONSE = 'ImportExportExcelResult';
  public static PARAMETER_TEXT_MULTIPLE_VALUES = 'Multiple values';
  public static SHOW_EDIT_DUPLICATE_ITEM_ALERT = 'showEditDuplicateElectricalItemAlert';
  public static SHOW_EDIT_DUPLICATE_ITEM_WINDOW = 'showEditDuplicateElectricalItemUI';

  //family information messages
  public static PLEASE_UPDATE_FAMILIES_AND_TRY_AGAIN = 'Please use updated families and try again.';
  public static PLEASE_ENTER_ID_FIELD = 'Please enter ID field.';
  public static CABLE_TRAY_ALREADY_EXISTS_IN_ANOTHER_SYSTEM =
    'Cable Tray Name already exists in another system. Please enter another name.';
  public static CONDUIT_ALREADY_EXISTS_IN_ANOTHER_SYSTEM =
    'Conduit Name already exists in another system. Please provide other name.';
  public static CABLE_TRAY_NAME_ALREADY_EXISTS_IN_REVIT = 'Cable tray name already exists in Revit.';
  public static CONDUIT_NAME_ALREADY_EXISTS_IN_REVIT = 'Conduit name already exists in Revit.';
  public static THIS_FAMILY_IS_ALREADY_ADDED_IN_SYSTEM = 'This family is already added in system.';
  public static PDF_FILE_DOES_NOT_EXIST = 'The specified PDF file does not exist.';
  public static DIAMETER_ALREADY_EXISTS_IN_CURRENT_SPECIFICATION = 'Diameter already exists in current Specification.';
  public static WIDTH_AND_DEPTH_ALREADY_EXISTS_IN_CURRENT_SPECIFICATION = 'Width and depth already exist in current Specification.';
  public static LENGTH_SHOULD_BE_GREATER_THAN_ZERO = 'Length should be greater than 0.';
  public static PLEASE_SELECT_AT_LEAST_ONE_SIZE = " Please select at least one size to generate a valid Conduit/CableTray in Revit.";
  public static PLEASE_ENTER_CABLE_TRAY_NAME = 'Please enter Cable Tray Name.';
  public static PLEASE_ENTER_CONDUIT_NAME = 'Please enter Conduit Name.';
  public static FAILED_TO_IMPORT = 'Failed to import.';
  public static EXPORTED_SUCCESSFULLY = 'Successfully exported ';
  public static ASSIGN_PROJECT_PARAMETER_ERROR = 'Something went wrong. Please contact administrator.';
  public static MODIFY_PROJECT_PARAMS_ERROR = 'Please enter the values for the selected parameter';
  public static SHOULD_BE_GREATER_OR_EQUAL_TO_ZERO = ' should be greater or equal to 0.';
  public static SHOULD_BE_GREATER_THAN_ZERO = ' should be greater than 0.';
  public static IMPORTED_SUCCESSFULLY = 'Data added successfully';
  public static DUPLICATE_PARAMETER_ERRORS = 'Please select unique project parameter.';
  public static INPUT_PARAMETER_NAME_ERROR = 'Please select project parameter(s).';
  public static INPUT_PARAMETER_VALUE_ERROR = 'Please enter value for project parameter.';
  public static ADD_PARAMETER_NAME_ERROR = 'Parameter Name is required';
  public static ADD_PARAMETER_CATEGORIES_ERROR = 'Please select categories';
  public static ADD_PROJECT_PARAMETER_RESPONSE = 'AddProjectParameterDataResult';
  public static ADD_PROJECT_PARAMETER_SUCCESSFULLY = 'Project Parameter successfully created.';
  public static ADD_SHARED_PARAMETER_SUCCESSFULLY = 'Shared Parameter successfully created.';
  public static ADD_PROJECT_PARAMETER_ERROR = 'Project Parameter already exists. Please provide another name.';
  public static ADD_SHARED_PARAMETER_ERROR = 'Shared Parameter already exists. Please provide another name.';
  public static ADD_PROJECT_PARAMETER_REVIT_PARAMS = 'AddProjectParameterRevitParams';
  public static LINE_GRAPHICS_FAILED = 'Failed to save line graphics info';
  public static ENTER_ADDED_WIRE_LENGTH = 'Enter Added Wire Length.';
  public static ENTER_MANUFACTURER_NAME = 'Enter Manufacturer Name.';
  public static ENTER_PART_ID = 'Enter Part ID.';
  public static ENTER_NOMINAL_SIZE = 'Enter Nominal Size.';
  public static SELECT_PDF_PATH = 'Select PDF Path.';
 
  // css classes keys
  public static ODD_BACKGROUND_SELECTED = 'odd-background-selected';
  public static ODD_BACKGROUND_UNSELECTED = 'odd-background-unselected';
  public static EVEN_BACKGROUND_SELECTED = 'even-background-selected';
  public static EVEN_BACKGROUND_UNSELECTED = 'even-background-unselected';
  public static UNBANDED_BACKGROUND_SELECTED = 'unbanded-background-selected';
  public static UNBANDED_BACKGROUND_UNSELECTED = 'unbanded-background-unselected';
  public static BANDED_BACKGROUND_SELECTED = 'banded-background-selected';
  public static BANDED_BACKGROUND_UNSELECTED = 'banded-background-unselected';

  //#endregion

  // add to system messages
  public static BACKUP_FAMILY = "Can't use backup family";
  public static NOT_METRIC_FAMILY = 'Please verify whether family is in Metric or not before adding';
  public static NOT_IMPERIAL_FAMILY = 'Please verify whether family is in Imperial or not before adding';
  public static FILE_NOT_AVAILABLE = 'File not available';
  public static INTERNET_CONNECTION = 'Connection to the internet is not detected and it is required';
  public static ALREADY_EXIST = 'This fitting is already present in selected system';
  public static BUILDING_LAYOUT_TAB = "Please add content to 'BuildingLayout' tab";
  public static ACCESORIES_CUSTOM_CONTENT_TAB = "Please add content to 'Accessories / CustomContent' tab";
  public static ASSEMBLIES_TAB = "Please add content to 'Assemblies' tab";
  public static CUSTOM_CONTENT_TAB = "Please add content to 'CustomContent' tab";
  public static ACCESORIES_TAB = "Please add content to 'Accessories' tab";
  public static CONDUIT_FIELD_FAB_TAB = "Please add content to 'Conduit/FieldFab' tab";
  public static LADDER_CABLE_TRAY_TAB = "Please add content to 'Ladder Cable Tray' tab";
  public static CLEARANCE_FITTINGS = 'Clearance and non-Clearance type fittings/tray cannot be in the same system';
  public static CHANNEL_CABLE_TRAY = "Please add content to 'Channel Cable Tray' tab";
  public static WIRE_MESH_CABLE_TRAY = "Please add content to 'Wire Mesh Cable Tray / BusWay / WireWay' tab";
  public static FAMILY_NOT_FOUND = 'Family not found';
  public static UPDATED_FAMILIES = 'Please use updated families and try again';
  public static ERROR = 'Family cannot be null';
  public static WRONG_TAB = 'Please add content to the correct tab';
  public static JUNCTION_BOX = "Please add only junction boxes to 'Accessories' tab.";
  public static BUILDING_LAYOUT_FAMILY = 'This is not valid building data family.';
  public static PROJECT_ADDED_SUCCESSFULLY = 'Project added successfully';
  public static PROJECT_ALREADY_EXISTS = 'Project name already exists';
  public static NO_INTERNET = 'No internet connection';
  public static ERROR_OCCURED = 'Error occurred';
  public static SERVICE_UNAVAILABLE = 'Service is unavailable at this time. Please yry after some time.';
  //#endregion

  // System State Manager Keys
  public static Docked2Fitting = 'FromDockedModeToAddFittingMode';
  public static Fitting2Docked = 'FromAddFittingModeToDockedMode';
  public static Fitting2Manage = 'FromFittingModeToManageMode';
  public static Manage2Fitting = 'FromManageModeToAddFittingMode';
  public static UpdateSystemInfoOnDockableFromAddFittings = 'UpdateSystemInfoOnDockableFromAddFittings';
  public static GetSystems = 'GetSystems';
  public static HangerSpecification = 'hangerSpecifications';  

  // Create/Delete/Rename System/Category Keys
  public static CategoryName = 'Category Name';
  public static SystemName = 'System Name';
  public static System = 'System';
  public static Category = 'Category';

  //Project data keys
  public static Common = 'Common';
  public static Structural = 'Structural';
  public static HVAC = 'HVAC';
  public static Energy = 'Energy';
  public static Electrical = 'Electrical';
  public static Piping = 'Piping';
  public static Infrastructure = 'Infrastructure';
  public static SelectAllText = 'selectAllText';
  public static IdentityData = 'Identity Data';
  public static Categories = 'Categories';
  public static Shared = 'Shared';
  public static Project = 'Project';
  public static Page = 'page';
  public static All = 'all';

  //Keys for message handler
  public static HandleWpfDialogs = 'HandleWPpfDialogs';
  public static HandleCommandsWithNoDialogs = 'HandleCommandsWithNoDialogs';
  public static RightClickDrawingCommand = 'OnRightClickDrawingCommand';
  public static DrawingCommand = 'OnDrawingCommand';
  public static CheckCustomContentFamilies = 'CheckIfMissingCustomFamilies';
  public static DownloadCustomContentFamilies = 'DownloadCustomContentFamilies';
  public static CheckMissingFamilies = 'CheckIfMissingFamilies';
  public static DownloadMissingFamilies = 'DownloadMissingFamilies';
  public static CheckUnreferencedFamilies = 'CheckIfUnreferencedFamilies';
  public static DownloadUnreferencedFamilies = 'DownloadUnreferencedFamilies';
  public static UpdateGenericFittings = 'UpdateGenericFittings';
  public static CloseBtnClick = 'CloseBtnClick';
  public static ApplyBtnClick = 'ApplyBtnClick';
  public static UpdateRetainValue = 'UpdateRetainValue';
  public static UpdateIsIgnoreValue = 'UpdateIsIgnoreValue';
  public static ValidateSelection = 'ValidateSelection';
  public static InitializeData = 'InitializeData';
  public static UpdateCouplingAlignmentValue = 'UpdateCouplingAlignmentValue';
  public static ChangeDialogDimensions = 'ChangeDialogDimensions';
  public static HangerSpecifications = 'hangerSpecifications';
  public static GetCategories = 'GetCategories';
  public static GetNewSystems = 'GetNewSystems';
  public static OnFolderPickerClick = 'OnFolderPickerClick';
  public static GetFittingsBySystemNameAndCategory = 'GetFittingsBySystemNameAndCategory';
  public static GetRootPath = 'GetRootPath';
  public static GetCircuitList = 'GetCircuitList';
  public static GetProjectList = 'GetProjectList';
  public static GetWireSpecList = 'GetWireSpecList';
  public static GetProcessStatus = 'GetProcessStatus';
  public static CheckPanelSystem = 'CheckPanelSystem';
  public static GetPanelList = 'GetPanelList';
  public static UpdateIsHangerNeeded = 'UpdateIsHangerNeeded';
  public static UpdateIsClearance = 'UpdateIsClearance';
  public static ProcessFittingsOnly = 'OnProcessFittingsOnly';
  public static rootPath = 'rootPath';
  public static SelectionExists = 'SelectionExists';
  public static DownloadFitting = 'DownloadFitting';
  public static SetRemoveDefaultFitting = 'SetRemoveDefaultFitting';
  public static EnableDisableFitting = 'EnableDisableFitting';
  public static DeleteItem = 'DeleteItem';
  public static CheckInvalidShortcuts = 'CheckInvalidShortcuts';
  public static GetConfigurationLocation = 'GetConfigurationLocationPath';
  public static OnApplyPreferencesClick = 'OnApplyPreferencesClick';
  public static OnApplyShortcutsClick = 'OnApplyShortcutsClick';
  public static LoadSystemModifiersKeys = 'LoadSystemModifiersKeys';
  public static LoadSystem = 'LoadSystem';
  public static OnImportClick = 'OnImportClick';
  public static OnBrowseClick = 'OnBrowseClick';
  public static ChangeHeight = 'ChangeHeight';
  public static ChangeHeightAndWidth = 'ChangeHeightAndWidth';
  public static OnApplyButtonClick = 'OnApplyButtonClick';
  public static OnToolBeltItemClick = 'OnToolBeltItemClick';
  public static OnCloseWindow = 'OnCloseWindow';
  public static OnClosePopupAction = 'OnClosePopupAction';
  public static GetCurateGroups = 'GetCurateGroups';
  public static GetInstallTypes = 'GetInstallTypes';
  public static GetManufacturers = 'GetManufacturers';
  public static GetProductTypes = 'GetProductTypes';
  public static GetSubProductTypes = 'GetSubProductTypes';
  public static GetMaterialTypes = 'GetMaterialTypes';
  public static GetTreeViewRootDirectory = 'GetTreeViewRootDirectory';
  public static UpdateNodeOnExpansionChanged = 'UpdateNodeOnExpansionChanged';
  public static LogicToExecuteForPasteItems = 'LogicToExecuteForPasteItems';
  public static LogicToExecuteForCopyCategory = 'LogicToExecuteForCopyCategory';
  public static CheckForDuplicateItemsInDestForCopyCategory = 'CheckForDuplicateItemsInDestForCopyCategory';
  public static CheckForDuplicateItems = 'CheckForDuplicateItems';
  public static GetProjectsList = 'GetProjectsList';
  public static AddProject = 'AddProject';
  public static OnAddProjectClick = 'OnAddProjectClick';
  public static ApplyPanelDataLogic = 'ApplyPanelDataLogic';
  public static GetVisibleInvisibleSystems = 'GetVisibleInvisibleSystems';
  public static OnExportButtonClicked = 'OnExportButtonClicked';
  public static ConfigurationLocationDialogName = 'Change Configuration Location';
  public static GetAllImportSystems = 'GetAllImportSystems';
  public static GetSystemsFromConfiguration = 'GetSystemsFromConfiguration';
  public static OnSystemManagerItemClick = 'OnSystemManagerItemClick';
  public static ImportSystemsLogic = 'ImportSystemsLogic';
  public static DuplicateSystemRequestName = 'DuplicateSystem';
  public static ReadParametersFromDocument = 'ReadParametersFromDocument';
  public static OnModifyMenuItemClick = 'OnModifyMenuItemClick';
  public static ImportExcelClick = 'ImportExcelClick';
  public static ExportExcelClick = 'ExportExcelClick';
  public static SaveSystemsChanges = 'SaveSystemsChanges';
  public static RotateElement = 'OnRotateElement';
  public static ShiftSegment = 'OnShiftSegment';
  public static ProcessEnable = 'OnProcessingEnabled';
  public static ShowNonStandardCall = 'OnShowNonStandard';
  public static OnClickedToOpenProjectData: string = 'OnClickedToOpenProjectData';
  public static CreateSystemRequestName = 'CreateSystem';
  public static RenameSystemRequestName = 'RenameSystem';
  public static DeleteSystemRequestName = 'DeleteSystem';
  public static CreateCategoryRequestName = 'CreateCategory';
  public static RenameCategoryRequestName = 'RenameCategory';
  public static DeleteCategoryRequestName = 'DeleteCategory';
  public static GetWorksharingStatus = 'GetWorksharingStatus';
  public static GetParamCategories = 'GetParamCategories';
  public static GetDefinitionGroupParameters = 'GetDefinitionGroupParameters';
  public static GetBuiltInGroupParameters = 'GetBuiltInGroupParameters';
  public static AddProjectParameter = 'AddProjectParameter';
  public static GetListOfSystems = 'GetListOfSystems';
  public static GetMainShape = 'GetMainShape';
  public static GetFittingTypes = 'GetFittingTypes';
  public static GetFittingsBySystemAndShape = 'GetFittingsBySystemAndShape';
  public static GetFittingsBySystemAndFittingType = 'GetFittingsBySystemAndFittingType';
  public static ReorderFittings = 'ReorderFittings';
  public static GetPatterns = 'GetPatterns';
  public static RotateSysQueConnect = 'RotateSysQueConnect';
  public static InitializeSysQueGauge = 'InitializeSysQueGauge';
  public static GetSysQueConnectFittingVariables = 'GetSysQueConnectFittingVariables';
  public static OpenUrl = 'OpenUrl';
  public static GetSelectedElementSystemName = 'GetSelectedElementSystemName';
  public static SaveNewFittingsOrder = 'SaveNewFittingsOrder';
  public static IsTooltipOn = 'IsTooltipOn';
  public static ShowReportIssue = 'ShowReportIssue';
  public static ShowRequestNewContent = 'ShowRequestNewContent';

  //general Keys
  public static ConduitId = 'Conduit ID';
  public static EquipmentDeviceId = 'Equipment / Device ID';
  public static AddDataParameters = 'Add Data Parameters';
  public static ConvertSystem = 'Convert System';
  public static PlaceCouplings = 'Place Couplings';
  public static PlaceCoupling = 'Place Coupling';
  public static Convert = 'Convert';
  public static Place = 'Place';
  public static Conduit = 'Conduit';
  public static FieldFabConduit = 'FieldFabConduit';
  public static ProcessFittingsOnlyKey = 'Process Fittings Only';
  public static ShowNonStandard = 'Show Non Standard';
  public static ProcessEnabled = 'Processing Enabled';
  public static Reporting = 'Reporting';
  public static Left = 'Left';
  public static Right = 'Right';
  public static DownloadMissingFamiliesToolbelt = 'Download Missing Families';
  public static UpdateFamilies = "Update Families";
  public static DirectTakeOff = "Direct Take Off";
  public static CheckForExceedingFill = 'Check for Exceeding Fill %';
  public static CheckForExceedingMaxAngle = 'Check for Exceeding Max Angle';
  public static CodeChecking = 'Code Checking';
  public static ApplyPanelCircuitData = 'Apply Panel/Circuit Data';
  public static ApplyEquipmentDetails = 'Apply Equipment Details';
  public static ApplySystemData = 'Apply System Data';
  public static ApplyNominalSize = 'Apply Nominal Size';

  //Confirmation keys
  public static Dismiss = 'Dismiss';
  public static No = 'No';
  public static Yes = 'Yes';
  public static LadderCableTray: string = 'Ladder Cable Tray';
  public static WireMeshCableTray: string = 'Wire Mesh Cable Tray';
  public static ChannelCableTray: string = 'Channel Cable Tray';
  public static BusWay: string = 'BusWay';
  public static WireWay: string = 'WireWay';
  public static CableTray: string = 'Cable Trays';
  public static Conduits: string = 'Conduits';
  public static CableTrayFittings: string = 'Cable Tray Fittings';
  public static ConduitFittings: string = 'Conduit Fittings';

  //Keys for right click menu options
  public static DownloadLatestFitting = 'download latest fitting';
  public static SetAsDefault = 'set as default';
  public static RemoveDefault = 'remove default';
  public static Paste = 'Paste';
  public static Copy = 'copy';
  public static Edit = 'edit';
  public static Duplicate = 'duplicate';
  public static Enable = 'enable';
  public static Disable = 'disable';
  public static Delete = 'delete';
  public static ReportIssue = 'report issue';
  public static ShowInEnclosingFolder = 'show in enclosing folder';
  public static CreateSystem = 'Create System';
  public static RenameSystem = 'Rename System';
  public static DeleteSystem = 'Delete System';
  public static CreateCategory = 'Create Category';
  public static DeleteCategory = 'Delete Category';
  public static RenameCategory = 'Rename Category';
  public static CopyCategoryToSystem = 'Copy Category to System';
  public static ShowInEnclosingFolderLabel = 'Show in Enclosing Folder';
  public static TakeOffAsMultiRackHanger = 'Take Off as MultiRack Hanger';
  public static PlaceHanger = 'Place Hanger';
  public static Dockable = 'Dockable';
  public static AddFittings = 'AddFittings';
  public static ManageMode = 'ManageMode';
  public static CopyMenu = 'Copy';
  public static DeleteMenu = 'Delete';
  public static DownloadLatestFittingMenu = 'Download Latest Fitting';
  public static ElectricalTypeItems = 'ElectricalTypeItems';
  public static AddDefaultItem = 'AddDefaultItem';
  public static DuplicateMenu = 'Duplicate';
  public static CustomContent = 'CustomContent';
  public static TakeOff = 'Take Off';
  public static Assemblies = 'Assemblies';
  public static MultiPort = 'MultiPort';
  public static TwoPointSaddle = 'Two Point Saddle';
  public static Kick90 = 'Kick 90';
  public static TakeOffCutIn = 'Take Off-Cut In';
  public static LadderCableTrayTee = 'LadderCableTrayTee';
  public static ChannelCableTrayTee = 'ChannelCableTrayTee';
  public static Saddle = 'saddle';
  public static ConduitCategory = 'Conduit';
  public static Stub = 'stub';
  public static EnableMenu = 'Enable';
  public static EditMenu = 'Edit';
  public static RemoveDefaultMenu = 'Remove default';
  public static SetAsDefaultMenu = 'Set as default';
  public static DisableMenu = 'Disable';
  public static BuildingLayoutCategory = 'BuildingLayout';
  public static FieldFabConduitCategory = 'FieldFabConduit';
  public static AddServiceMenuItem = 'Add Service';
  public static RemoveServiceMenuItem = 'Remove Service';
  public static LineGraphicsMenuItem = 'Define Line Graphics';
  public static Accessories = 'Accessories';
  public static Cap = 'Cap';
  public static TakeOffByLength = 'Take-Off by Length';
  public static DIAMETER = 'diameter';
  public static HEIGHT_AND_WIDTH = 'heightAndWidth';
  public static TAKE_OFF_BY_LENGTH_KEY = 'take-off by length';

  //keys for copy fittings
  public static CopiedItems = 'copiedItems';
  public static DuplicateItemsUpdate = 'duplicateItemsUpdate';
  public static ReplaceItemsUpdate = 'replaceItemsUpdate';
  public static SrcCopiedItems = 'srcCopiedItems';
  public static CanExecutePasteLogic = 'canExecutePasteLogic';
  public static ReplaceItemTitle = 'Replace Item';
  public static ReplaceItemContent = 'Do you wish to replace the ';
  public static FittingsBelogsTo = "Fittings belong to '";
  public static PleasePasteIn = "' tab. Please paste in '";

  //Keys for copy category
  public static CopyCategoryReplaceDuplicate = 'copyCategoryReplaceDuplicate';
  public static CopyCategoryIsHangerSetUp = 'copyCategoryIsHangerSetUp';
  public static ShowHangerSetUp = 'showHangerSetUp';
  public static BuildingLayout = 'buildinglayout';
  public static CopyCategory = 'copyCategory';
  public static CopyHangerCategoryToSystem = 'copyHangerCategory';
  public static HangerCopySetUp = 'hangerCopySetUp';
  public static CopyCategoryHangerItems = 'hangerItemList';

  //Keys for sysque gauge
  public static TitleForSysQueConnect = 'SysQue Connect';
  public static BodyForSysQueConnect =
    'Face-Based fittings are not operational in SysQueConnect. Therefore, SysQueConnect will be deleted.';

  //Keys for messages
  public static TitleForUnableToDownloadLatestFitting = 'Unable to download latest fitting';
  public static BodyForUnableToDownloadLatestFitting =
    this.TitleForUnableToDownloadLatestFitting + '. Please contact administrator';
  public static TitleForDefaultPosition = 'Setting default position';
  public static BodyForUnavailableDefaultPosition = ' not available to set Default Position.';
  public static BodyForNoSystemDef = 'No SystemDef available.';
  public static BodyForErrorDefaultPosition = 'Error encountered while setting default position. Please try again.';
  public static TitleForDisableEnablePosition = 'Enable/disable position';
  public static BodyForErrorDisableEnablePosition = 'Error encountered while disable/enable. Please try again.';
  public static ProcessEnabledStop = 'To resume, toggle "Processing Enabled" in your Toolbelt';
  public static ProcessEnabledTitle = 'Processing is paused';
  public static AssemblySelected =
    'The current selection contains one or more assemblies. Please disassemble or redefine the selection.';
  public static RotateElementIncorrectStructure = 'Please select proper structure for rotation.';
  public static RotateElementInvalidSelection =
    'Coupling besides the fitting/straight should be selected for rotation.';
  public static ShiftElementFieldFabSelected = "Can't move FieldFabConduit.";
  public static TetherConfigurationTitle = 'Tethered configuration';
  public static TetherConfigurationText = 'Please sync/save your project to complete the Project Linking.'
  public static TitleNoSystemSelected = 'No system selected';
  public static BodyNoSystemSelected = 'Please select at least one system.';
  public static InvalidSelection = "Invalid selection";
  public static SystemNameDoesNotExist = "System name does not exist.";
  public static FeatureMayNotWorkWithSelection = "This feature may not work with the current selection.";
  public static SelectConduitCableTrayFitting = "Please select at least one Conduit/CableTray/Fitting."
  public static FeatureIncludedOnlyInSubscription = 'This feature is included in Subscription only. Please contact your sales rep for more information.';

  //#region Keys for download missing/unreferenced/generic families messages

  public static Downloading = 'Downloading';
  public static TitleForUnableToDownloadMissingFamilies = 'Unable to download missing families';
  public static BodyForUnableToDownloadMissingFamilies =
    this.TitleForUnableToDownloadMissingFamilies + '. Please contact administrator';
  public static MissingFamilies = 'All missing families';
  public static UnreferencedFamilies = 'Unreferenced families for ';
  public static DownloadMissingFamiliesTitle = 'Download missing families';
  public static DownloadMissingFamiliesBody =
    'SysQue has found there are families missing. Would you like to download these now?';
  public static DownloadUnreferencedFamiliesTitle = 'Download unreferenced families';
  public static DownloadUnreferencedFamiliesBody =
    'The system has found that there are unreferenced families in your systems, would you like the system to download these for you now?';
  public static TitleForUnableToDownloadUnreferencedamilies = 'Unable to download unreferenced families';
  public static BodyForUnableToDownloadUnreferencedFamilies =
    this.TitleForUnableToDownloadUnreferencedamilies + '. Please contact administrator';
  public static NoRootPath = 'No Root Path selected';
  public static SelectRootPath = 'Please select Root Path for the families.';
  public static TitleForUpdateGenericFittings = 'Update generic fittings';
  public static BodyForUpdateGenericFittings = 'Do you want to update generic fittings? It takes a bit of time depending on the number of generic families and internet speed.';
  public static BodyForUpdateGenericFittingsError = 'Unable to download generic families';
  public static GenericFamilies = 'Generic families';
  public static MissingFamiliesType = 'Missing families';
  public static NoMissingFamiliesBody = 'No missing families found';
  public static UnableToDownloadGenericFamiliesTitle = 'Unable to download generic families';
  public static UnableToDownloadGenericFamiliesBody = 'Please contact administrator';
  public static TitleForEditDuplicateElectricalItem = 'New Electrical Type creation';
  public static BodyForEditDuplicateElectricalItem = 'Do you want to create a new Electrical Type by duplicating?';

  //#endregion

  //#region Keys for invalid shortcuts

  public static InvalidShortcutsTitle = 'Invalid shortcut';
  public static InvalidShortcutsBody = "Please re-assign Menu's shortkeys.";

  //#endregion

  //#region Apply conduit/equipment id

  // event keys
  public static ApplyIdResponseKey = 'applyIdResponse';
  public static DeviceEquipmentDetailsApplyDataResponse = 'deviceEquipmentDetailsApplyDataResponse';
  public static ApplyDataResponse = 'applyDataResponse';

  //messages
  public static ConduitIdSuccessfullyApplied = 'Conduit ID successfully applied.';
  public static EquipmentIdSuccessfullyApplied = 'Equipment/Device ID successfully applied.';
  public static PleaseEnterValidId = 'Please enter a valid ID';
  public static SelectionInvalidSelectSomething = 'Selection invalid, please select something.';
  public static SelectionInvalidSelectConduit = 'Selection invalid, please select conduit selection.';
  public static SelectionInvalidSelectEquipment = 'Selection invalid, please select equipment or device selection.';

  //#endregion

  //Keys for messages for Apply Panel/Circuit Data from toolbelt
  public static SelectApplyPanelSelectionRequired = 'Structure Selection Required';
  public static SelectApplyPanelSelectionMismatch = 'Selection mismatch';
  public static SelectApplyPanelSelectionStructure = 'Please select some structure.';
  public static SelectApplyPanelSelectConduit = 'Please select conduits and try again.';
  public static SelectApplyPanelSuccessfully = 'Panel/Circuit Data successfully applied.';
  public static SelectFittingToApply = 'Please select fittings to Apply Panel/Circuit Data.';

  //Keys for messages for Apply Panel/Circuit Data from Dockable
  public static SelectDockableApplyPanelErrorTitle = 'Panel/Circuit Data failed';
  public static SelectDockableApplyPanelErrorBody = 'Invalid fitting(s) selection to Apply Panel/Circuit Data';
  public static SelectDockableApplyPanelApplied = 'Panel/Circuit Data applied';
  public static SelectDockableApplyPanelAppliedBody = 'Panel/Circuit Data applied for fitting(s) successfully.';

  //Keys for messages for Apply Wire Fill Spec Data from Dockable
  public static SelectDockableApplyWireFillErrorBody = 'Invalid fitting(s) selection to Apply Wire Fill Spec';
  public static SelectDockableApplyWireFillAppliedBody = 'Wire Fill Spec applied for';
  public static SelectDockableApplyWireFillAppliedWithFittingCount = 'fitting(s) successfully.';
  public static SelectDockableApplyWireFillErrorTitle = 'Wire Fill Spec failed';
  public static SelectDockableApplyWireFillApplied = 'Wire Fill Spec applied';

  //Keys for common messages for Apply Data from Dockable
  public static SelectDockableDataSelectConduitBody =
    'Selection has cable trays, please select conduits only and try again.';
  public static SelectDockableDataSelectCableBody =
    'Selection has conduits, please select cable trays only and try again.';

  //Keys for messages for copy fitting in manage mode
  public static CustomContentFitting = 'Fittings belong to CustomContent tab. Please paste in CustomContent tab.';
  public static BothSelectedSystemSame = 'Fittings are copied from selected system. Please paste in another system.';
  public static ClearanceSystemTypeMisMatch =
    'Clearance and non-Clearance type fittings/trays cannot be in the same system.';
  public static DoReplaceExistingItem = "'already exists. Do you want to replace?";
  public static CategoryMismatched = "Fittings belong to '";
  public static CategoryMismatchedPart = "' tab.Please paste in '";
  public static CategoryMismatchedPart2 = "' tab.";

  //Keys for messages for copy category in manage mode
  public static CopyCategoryClearanceSystemTypeMisMatchTitle = 'Cannot paste in different type trays';
  public static CopyCategorySameSystem = 'The selected category already exists in the destination system.';
  public static CopyCategoryAlreadyExistPart = 'Some straight(s) or fitting(s) already exist in';
  public static CopyCategoryMismatched = 'The selected items must be copied to the ';
  public static CopyCategoryMismatchedPart = ' category.';
  public static CopyCategoryDoReplaceExistingPart = 'Do you want to replace?';
  public static CopyCategoryDoReplaceExistingTitle = 'Some fitting(s) exist';
  public static CopyCategoryDoReplaceExistingBody = "'Do you wish to replace the' ";
  public static HangerSetUpAlertTtitle = 'Specification Details Missing';
  public static HangerSetUpAlertBody =
    'To use the hangers in this system you will need to set them up, would you like to do this now?';
  public static HangerSetUpAlertTitle = 'Specification details missing';
  public static NameMustNotStartWithNumber = 'Name must start with alphabetic character';
  public static TitleForDeleteFitting = 'Delete Process';
  public static TitleForUnableDelete = 'At least one ';
  public static BodyForDeleteFitting = 'Do you want to delete?';
  public static BodyForUnableDelete = "Can't delete ";
  public static BodyForErrorDelete = 'Error encountered while deleting. Please try again.';
  public static ErrorCategoryOptions = 'Some error occurred. Please try again.';
  public static SystemExportSuccess = 'SysQue Systems exported successfully';
  public static NoSysQueSystem = 'Please select SysQue Systems';
  public static NameAlreadyExists = ' name already exists';
  public static GenericTab = 'Generic Tab name not allowed in CustomContent';
  public static SystemError = 'System option error';
  public static CustomContentDelete = "Can't delete ";
  public static CustomContentTabRequired = 'At least one CustomContent tab is required.';
  public static ReorderingFailed = 'Unable to save system order changes';

  // Keys for System Manager
  public static ContainmentKey = 'Containment';
  public static AllSystemKey = 'All Systems';
  public static DialogName = 'System Manager';
  public static ColumnsName: string[] = ['Order', 'Visible', 'Description'];
  public static ChangesSaveSuccessfully = 'Changes have been applied successfully';
  public static ReorderingSystemsFailed = 'Unable to save system order changes';

  // Keys for Change Configuration Location
  public static PathLabel = 'Current path';
  public static LinkProject = 'Link configuration to project?';
  public static RevertConfigurationLocation = 'GetLastSavedConfigurationLocation';
  public static GetConfigurationLocationPath = 'GetConfigurationLocation';
  public static ApplyConfigurationLocationPath = 'OnApplyConfigurationLocation';
  public static SetTetherConfigurationLocationPath = 'SetTetheredConfigurationLocation';

  //#region Convert Options Dialog

  public static ConvertSystemBody = 'The object data will migrate to:';
  public static RetainTheExistingObjectData = 'Retain the following existing object data';
  public static AlertNameConvertSystem = 'Caution';
  public static IgnoreMessageForSysQueSession = 'Ignore this message for this SysQue session';
  public static ServiceTypeNameAndColor = 'Service Type Name and Color';
  public static ConduitIdNumberAndFilter = 'Conduit ID, Conduit Number, and Conduit Filter';
  public static ValuesOfSharedProjectParameters = 'Values of shared project parameters';
  public static FittingsDoNotSupportConvertSystem = 'Some Fittings do not support Convert System functionality.';
  public static SelectAtLeastOneFabConduit = 'Please Select at least one FabConduit.';
  public static FabConduitTypeRequired = 'FabConduit Type Required.';
  public static FabConduitTypeNotAvailable = 'This Fab Conduit Type is not Available.';
  public static SelectAtLeastOneCableTray = 'Please select at least one CableTray.';
  public static CableTrayTypeRequired = 'CableTray Type Required.';
  public static CableTrayTypeNotAvailable = 'This CableTray Type is not Available.';
  public static CableTraySizeNotFound = 'CableTray Size not found for the Selected System.';
  public static WarningToAvoidLossOfCustomData =
    'To avoid loss of custom data parameters values, verify the custom project data is also in the destination system prior to conversion';
  public static PleaseSelectAtLeastOneSystem = 'Please Select at least one System.';
  public static SelectedStructureDoesNotSupport = 'Selected structure is not supported.';
  public static AlignedCouplingButton = 'Aligned';
  public static OptimizedCouplingButton = 'Optimized';
  public static SelectCouplingAlignment = 'Select Coupling Alignment';

  //#endregion

  //#region Import System(s) Dialog

  public static ImportSystemTitle = 'Import System(s)';
  public static ErrorSystems = 'Error';
  public static ImportSystemFailed = 'Import System(s) failed';
  public static CheckSystemName = 'Please verify system name(s)';
  public static SystemNameExistsInConfiguration = 'System name already exist in Configuration';
  public static NameAlreadyInUse = 'Name is already in use';
  public static Exist = 'exist';
  public static Alphabet = 'alphabet';
  public static Same = 'same';

  //#endregion

  //#region Fitting Prioritization

  public static FittingPrioritizationTitle = 'Fitting Prioritization';
  public static ShapePlaceholder = 'Shape';
  public static FittingTypePlaceholder = 'Fitting Type';
  public static FittingPrioritizationColumns: string[] = ['Order', 'Description'];
  public static ShapeKey = 'shape';
  public static ReorderingFittingsFailed = 'Unable to save fittings order changes';
  public static Elbow = 'Elbow';
  public static JunctionBoxElbow = 'JunctionBoxElbow';
  public static Tee = 'Tee';
  public static JunctionBoxTee = 'JunctionBoxTee';
  public static Cross = 'Cross';
  public static JunctionBoxCross = 'JunctionBoxCross';

  //#endregion

  //#region Buttons name

  public static ScheduleButton = 'Schedule name';
  public static ImportButton = 'Import';
  public static ApplyButton = 'Apply';
  public static RevertButton = 'Revert to default';
  public static ImportSystemsButton = 'Import System(s)';
  public static ExportButton = 'Export System(s)';
  public static CancelRequestButton = 'Cancel Request';
  public static AddSystemButton = 'Add System';
  public static CancelButton = 'Cancel';
  public static CreateButton = 'Create';
  public static DuplicateButton = 'Duplicate';
  public static RevertChangesButton = 'Revert Changes';
  public static SaveOrderButton = 'Save Order';
  public static AddComponentButton = 'Add Component';
  public static RestoreDefaultsButton = 'Restore defaults';

  //#endregion

  //#region System Manager context menu

  public static DuplicateMenuItem = 'Duplicate';
  public static RenameMenuItem = 'Rename';
  public static SetComponentPriorityMenuItem = '"Set Component Priority"';
  public static DeleteMenuItem = 'Delete';

  //#endregion

  //#region Keys for HTML elements

  public static HangerNeeded = 'Hanger Needed?';
  public static ApplyToSelection = 'Apply to Selection';

  //#endregion

  //#region Windows key
  
  public static DockableKey = 'sp';
  public static SystemManageKey = 'SystemManager';
  public static AddFittingsKey = 'adf';
  public static ManageSrcKey = 'src';
  public static ManageDestKey = 'dest';

  //#endregion

  //#region Worksharing alerts

  public static WorksharingSyncNecessaryBody =
    'SysQue has made changes to your electrical elements. ' +
    'If you have other users that will require the use of SysQue Electrical elements, it is recommended that you Sync ' +
    'your project to Central and relinquish your elements before continuing.';
  public static WorksharingSyncNecessaryTitle = 'New changes in the model';

  public static WorksharingProgressTitle = 'Synchronizing Generics';
  public static WorksharingProgressBody = 'Includes Generic families, SysQue Connect, Annotations and Materials';

  public static DuplicationDefaultTypeNotFoundTitle = 'Default Conduit/CableTray type not available';
  public static DuplicationDefaultTypeNotFoundBody = 'The selected system does not have a Revit default system type to start from. ' +
    'Please create one by drawing a standard Revit Conduit/CableTray and try again.';

  //#endregion

  //#region Processing alerts

  public static ProcessingTitle = 'Processing';
  public static ProcessingStartBody = 'Initializing...';
  public static ProcessingWorksharingNoAccessTitle = 'Permission checking';
  public static ProcessingWorksharingNoAccessBody =
    'You do not appear to have permission or access to this model.' +
    ' Please either try again with a different user name, modify the collaboration settings, or contact your admin.';
  public static ProcessingNoActiveDocumentTitle = 'No active document';
  public static ProcessingNoActiveDocumentBody = "There's no active document in Revit";
  public static ProcessingElements = 'element(s) processed.';
  public static ProcessingFittings = 'fitting(s) processed.';
  public static ProcessingCableTrayFittings = 'cable tray fitting(s)';
  public static ProcessingCableTrays = 'cable tray(s)';
  public static ProcessingConduitFittings = 'conduit fitting(s)';
  public static ProcessingConduits = 'conduit(s)';
  public static ProcessingFieldFabConduits = 'Fab conduit(s)';
  public static ProcessingExtendTrimErrorTitle = 'Extend/Trim';
  public static ProcessingExtendTrimErrorBody =
    "We're unable to process the fitting(s) because it is trying to connect to two different service types.";
  public static ProcessingConduitRunsBendAngleErrorTitle = 'Information';
  public static ProcessingConduitRunsBendAngleErrorBody =
    'The conduit runs currently being processed exceed the maximum' +
    ' bend angle and/or the maximum percent fill. Please run the maximum bend angle command and percent fill command from the' +
    ' Tool Menu on each run to determine which run(s) has an error.';
  public static ProcessingConduitRunsAngleErrorBody =
    'The total angle of this conduit run has exceeded the maximum angle defined in Conduit Settings. Maximum angle = ';
  public static ProcessingConduitRunsAngleErrorBodyCurrentRun = ', Current run = ';
  public static ProcessingConduitRunsAngleNotExceededBody = 'The total angle of this conduit run has not exceeded the maximum angle defined in Conduit Settings. Maximum angle = ';
  public static ProcessingFabConduitsConnectivityBody = 'Fab conduits are processed for connectivity.';

  //#endregion

  //#region Dockable Error Messages

  public static NO_DUPLICATE_TYPE = 'NoDuplicateType';
  public static WORKSHARING_SYNC = 'WorksharingSync';
  public static PROCESSING_NO_ACCESS = 'ProcessingNoAccess';
  public static PROCESSING_NO_ACTIVE_DOCUMENT = 'ProcessingNoActiveDocument';
  public static PROCESSING_EXTEND_TRIM_ERROR = 'ProcessingExtendTrimError';
  public static PROCESSING_CONDUIT_RUNS_BEND_ANGLE_ERROR = 'ProcessingConduitRunsBendAngleError';
  public static PROCESSING_CONDUIT_RUNS_ANGLE_ERROR = 'ProcessingConduitRunsAngleError';
  public static SELECTION_MISMATCH_CABLETRAY = 'SelectionMismatchCableTray';
  public static INVALID_SELECTION = 'InvalidSelection';
  public static SELECTION_MISMATCH_CONDUITS = 'SelectionMismatchConduits';
  public static FAMILY_NOT_EXISTS = 'FamilyNotExists';
  public static SELECTION_MISMATCH_EQUIPMENT = 'SelectionMismatchEquipment';
  public static SPECIFICATION_MISSING = 'SpecificationMissing';
  public static CODE_CHECKING_EXCEEDING_MAXIMUM_ANGLE = 'CodeCheckingExceedingMaximumAngle';
  public static WIRE_FILL_SPEC_INFORMATION_NOT_AVAILABLE = 'WireFillSpecInformationNotAvailable';
  public static COMMENTS_OR_CONDUIT_ID_MISSING = 'CommentsOrConduitIdMissing';
  public static CONDUITFILL_EXCEEDING_40PERCENT_CHECKING = 'ConduitFillExceeds40PercentCheckingOrNotError';
  public static UNABLE_TO_PROCESS_FITTINGS_ERROR = 'UnableToProcessFittingsError';

  public static SelectionMismatchCableTrayTitle = 'Selection mismatch';
  public static SelectionMismatchCableTrayBody = 'Selection has Cable Trays. Please select Conduits only and try again.';

  public static SelectionMismatchConduitsBody = 'Selection has Conduits. Please select Cable Trays only and try again.';

  public static SpecificationMissingTitle = 'Specification missing';
  public static SpecificationMissingBody = 'Please apply Specification and try again.';

  public static InvalidSelectionTitle = 'Invalid selection.';
  public static InvalidSelectionBody = 'Please select only one structure at a time.';

  public static SelectionMismatchEquipmentBody = 'Please select only one Equipment/Device and try again.';

  public static FamilyNotExistsTitle = 'Family does not exist';
  public static FamilyNotExistsBody = 'To apply Device/Equipment details, the family should be in the physical path.';

  public static ApplyNominalSizeTitle = 'Applying nominal sizes';
  public static UpdatingNominalSizeStatusBody = 'Updating nominal sizes for';
  public static UpdatingNominalSizeStatusBodyElements = 'element(s).';

  public static UpdateExtendedDataStatusTitle = 'Update extended data';
  public static UpdatingExtendedDataStatusBody = 'Updating extended data for';

  public static WireFillSpecInformationNotAvailableTitle = 'Information not available';
  public static WireFillSpecInformationNotAvailableBody = '[Wire Fill Spec] parameter is not available in Family / parameter is blank.';

  public static CommentsOrConduitIdMissingTitle = 'Comments/ConduitID missing';
  public static CommentsOrConduitIdMissingBody = 'Please apply Comments/ConduitID with \'Apply Conduit ID\' menu option.';

  public static UnableToProcessFittingsErrorTitle = '"Extend/Trim"';
  public static UnableToProcessFittingsErrorBody = "We're unable to process the fitting(s) because it is trying to connect to two different service types.";

  public static ConduitFillExceeds40PercentCheckingOrNotErrorTitle = 'Conduit fill';
  public static ConduitFillExceeds40PercentCheckingErrorBody = 'Conduit fill exceeds 40% checking.';
  public static ConduitFillNotExceeds40PercentCheckingErrorBody = 'Conduit fill does not exceed 40% checking.';
  public static ConduitFillExceedsNecMAximumFillBody = 'Conduit fill exceeds NEC maximum fill capacity.';
  //#endregion
}

// map between routing and the dialog name
// for allowing a call like: http://localhost:4200/dialog/about-dialog
// this will be called from backend to get the specific dialog
// and show it in wpf
export const dialogMap = new Map<string, string>([
  ['about-dialog', GlobalConstants.ABOUT_ELECTRICAL_NAME_DIALOG],
  ['import-schedule-dialog', GlobalConstants.IMPORT_SCHEDULE_NAME_DIALOG],
  ['create-system-dialog', GlobalConstants.CREATE_SYSTEM_NAME_DIALOG],
  ['rename-system-dialog', GlobalConstants.RENAME_SYSTEM_NAME_DIALOG],
  ['delete-system-dialog', GlobalConstants.DELETE_SYSTEM_NAME_DIALOG],
  ['create-category-dialog', GlobalConstants.CREATE_CATEGORY_NAME_DIALOG],
  ['rename-category-dialog', GlobalConstants.RENAME_CATEGORY_NAME_DIALOG],
  ['delete-category-dialog', GlobalConstants.DELETE_CATEGORY_NAME_DIALOG],
  ['apply-panel-data-dialog', GlobalConstants.APPLY_PANEL_DATA_NAME_DIALOG],
  ['configuration-location-dialog', GlobalConstants.CONFIGURATION_LOCATION_NAME_DIALOG],
  ['place-coupling-dialog', GlobalConstants.PLACE_COUPLING_DIALOG],
  ['convert-system-dialog', GlobalConstants.CONVERT_SYSTEM_DIALOG],
  ['apply-conduit-id', GlobalConstants.APPLY_CONDUIT_ID_DIALOG],
  ['apply-equipment-device-id', GlobalConstants.APPLY_EQUIPMENT_ID_DIALOG],
  ['add-fitting', GlobalConstants.ADD_FITTING_DIALOG],
  ['annotation-settings-dialog', GlobalConstants.ANNOTATION_SETTINGS_DIALOG],
  ['specification-settings-dialog', GlobalConstants.SPECIFICATION_SETTINGS_DIALOG],
  ['electrical-settings-dialog', GlobalConstants.ELECTRICAL_SETTINGS_DIALOG],
  ['cable-tray-family-information-dialog', GlobalConstants.CABLE_TRAY_FAMILY_INFORMATION_DIALOG],
  ['conduit-family-information-dialog', GlobalConstants.CONDUIT_FAMILY_INFORMATION_DIALOG],
  ['junction-box-family-information-dialog', GlobalConstants.JUNCTION_BOX_FAMILY_INFORMATION_DIALOG],
  ['field-fab-family-information-dialog', GlobalConstants.FIELD_FAB_FAMILY_INFORMATION_DIALOG],
  ['hand-and-machine-bend-family-information-dialog', GlobalConstants.HAND_AND_MACHINE_BEND_FAMILY_INFORMATION_DIALOG],
  ['kick-hand-and-machine-bend-family-information-dialog', GlobalConstants.KICK_HAND_AND_MACHINE_BEND_FAMILY_INFORMATION_DIALOG],
  ['user-custom-content-family-information-dialog', GlobalConstants.USER_CUSTOM_CONTENT_FAMILY_INFORMATION_DIALOG],
  ['hanger-specification-family-information-dialog', GlobalConstants.HANGER_SPECIFICATION_FAMILY_INFORMATION_DIALOG],
  ['device-equipment-family-information-dialog', GlobalConstants.APPLY_EQUIPMENT_DETAILS],
  ['system-manager-dialog', GlobalConstants.SYSTEM_MANAGER_DIALOG],
  ['add-new-project-dialog', GlobalConstants.ADD_NEW_PROJECT_DIALOG],
  ['project-data-dialog', GlobalConstants.PROJECT_DATA_DIALOG],
  ['import-systems-dialog', GlobalConstants.IMPORT_SYSTEMS_DIALOG],
  ['field-fab-marks', GlobalConstants.FIELDFAB_MARKS_DIALOG],
  ['conduit-run-edit', GlobalConstants.CONDUITRUN_EDIT_DIALOG],
  ['align-couplings', GlobalConstants.ALIGN_COUPLINGS_DIALOG],
  ['object-unite', GlobalConstants.OBJECT_UNITE_DIALOG],
  ['duplicate-system-dialog', GlobalConstants.DUPLICATE_SYSTEM_NAME_DIALOG],
  ['assign-project-data', GlobalConstants.ASSIGN_PROJECT_DIALOG],
  ['add-new-project-parameter', GlobalConstants.ADD_NEW_PROJECT_PARAMETER_DIALOG],
  ['fitting-prioritization-dialog', GlobalConstants.CHANGE_PRIORITY_DIALOG],
  ['sysque-gauge-dialog', GlobalConstants.SYSQUE_GAUGE_DIALOG],
]);